import axiosClient from "../lib/axiosClient";
import { routes } from "../lib/routes";

export const getMe = async () => {
  return await axiosClient.get(routes.users.getMe);
};

export const logIn = async (values) => {
  return await axiosClient.post(routes.users.login, values);
};

export const forgotPassword = async (values) => {
  return await axiosClient.post(routes.users.forgotPassword, { email: values.email });
};
export const setPasswordLink = async (values) => {
  return await axiosClient.post(routes.users.requestPasswordResetLink, {
    email: values.email,
  });
};

export const signUp = async (values) => {
  return await axiosClient.post(routes.users.signUp, values);
};

export const setPassword = async (values) => {
  return await axiosClient.patch(
    `${routes.users.setPassword}/${values.token}`,
    values
  );
};

export const getAllDeactivatedUsers = async () => {
  return await axiosClient.get(routes.users.deactivatedUsers);
};

export const getAllActivatedUsers = async () => {
  return await axiosClient.get(routes.users.activatedUsers);
};

export const activateUser = async (id) => {
  return await axiosClient.post(routes.users.activateUser, id);
};

export const addUserDepartment = async (values) => {
  return await axiosClient.post(routes.users.addUserDepartment, values);
};

export const requestPasswordLink = async (id) => {
  return await axiosClient.post(routes.users.requestPasswordLink, id);
};

// HR approves a join request: activate the account first, so it leaves
// "Pending approval" even if email fails, then email the set-password link.
// Resolves to { emailSent }: false when the email couldn't be sent, true when
// it was, undefined when the API doesn't say (older API versions).
export const approveUser = async ({ id }) => {
  await axiosClient.post(routes.users.activateUser, { id });
  try {
    const result = await axiosClient.post(routes.users.requestPasswordLink, {
      id,
    });
    return { emailSent: result?.emailSent };
  } catch {
    return { emailSent: false };
  }
};

export const updateProfile = async (values) => {
  return await axiosClient.patch(routes.users.updateProfile, values);
};

export const getAllDistricts = async () => {
  return await axiosClient.get(routes.users.getAllDistricts);
};

export const getAllCounties = async () => {
  return await axiosClient.get(routes.users.getAllCounties);
};

export const getAllParishes = async () => {
  return await axiosClient.get(routes.users.getAllParishes);
};

export const getAllVillages = async () => {
  return await axiosClient.get(routes.users.getAllVillages);
};

export const getAllSubCounties = async () => {
  return await axiosClient.get(routes.users.getAllSubCounties);
};

export const getDistrictSubCounties = async (districtId) => {
  return await axiosClient.get(
    `${routes.registration.getDistrictSubCounty}/${districtId}`
  );
};

export const getDistrictCounties = async (districtId) => {
  return await axiosClient.get(`${routes.users.getCountiesByDistrict}/${districtId}`);
};

export const getCountySubcounties = async (countyId) => {
  return await axiosClient.get(`${routes.users.getSubcountiesByCounty}/${countyId}`);
};

export const getSubcountyParishes = async (parishId) => {
  return await axiosClient.get(`${routes.users.getParishesBySubcounty}/${parishId}`);
};

export const getParisheVillages = async (parishId) => {
  return await axiosClient.get(`${routes.users.getVillagesByParish}/${parishId}`);
};

export const getLocationNames = async (locationIds) => {
  return await axiosClient.get(routes.users.getLocationNames, { params: locationIds });
};
